/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { Divider, Typography } from '@mui/material'
import { T } from '@tolgee/react'

function TermsAndConditions() {
  return (
    <div>
      <T
        keyName="termsAndConditions.text"
        params={{
          divider: () => <Divider sx={{ marginTop: 2, marginBottom: 2 }} />,
          newline: () => <br />,
          header: content => (
            <Typography variant="h4" sx={{ marginTop: 2 }}>
              {content}
            </Typography>
          ),
        }}
      />
    </div>
  )
}

export default TermsAndConditions
